const pspTitle = "Patient Support Program"
const footerImageAltText = "popping flower from botton to top"
const backgroundImageAltText = "Background Image"
export const LANDING_PAGE_DATA = {
    widgets: {
        analytics: {
            category: "Home",
        },
        mixpanelData: {
            common: {
                page_name: "home",
                category: "corporate_partnership",
            },
        },
        heroSection: {
            isLeftAligned: false,
            header: "<span>Let’s <span style='color:#FF5443'>Empower </span>Healthcare <span style='color:#FF5443'>Together </span></span>",
            subHeader:
                "<span>Partner with India’s trusted healthcare platform to deliver care, enhance efficiency and improve health outcomes</span>",
            backgroundImageDweb: {
                url: "https://onemg.gumlet.io/staging/041acb4e-d249-4faf-aaed-0cbb53721f3f.svg",
                alt: "Hero Image",
            },
            backgroundImageMweb: {
                url: " https://onemg.gumlet.io/staging/c88a90df-d62a-46b1-82d7-1f37d802403b.svg",
                alt: "Hero Image",
            },
            cta: {
                label: "Know more about us",
                url: "/",
            },
            key: "CorporateLadingPage",
        },
        supportSection: {
            header: "<span>India’s Largest<span style='color:#FF5443' > Integrated Healthcare Platform</span></span>",
            listTitle: "Supported by",
            list: [
                {
                    title: "ePharmacy",
                    image: {
                        url: "https://onemg.gumlet.io/staging/b89b5b0b-56e4-4038-9654-cad9b24a725a.svg",
                        alt: "ePharmacy",
                    },
                    description:
                        "Fast and reliable home delivery of genuine medicines and health essentials across 19000+ pincodes.",
                },
                {
                    title: "eDiagnostics",
                    image: {
                        url: "https://onemg.gumlet.io/staging/b07f3889-b2fa-4f1a-bbf8-653992912000.svg",
                        alt: "eDiagnostics",
                    },
                    description:
                        "Online lab test booking service with our certified labs, complete with convenient at-home sample collection and online reports.",
                },
                {
                    title: "eConsultations",
                    image: {
                        url: "https://onemg.gumlet.io/staging/96df8863-e2fb-4b10-9636-55456c4c6eef.svg",
                        alt: "eConsultations",
                    },
                    description: "Immediate and free access to qualified doctors for virtual consultations.",
                },
            ],
            statsImage: {
                url: "https://onemg.gumlet.io/staging/3c9bc782-09e6-45ca-8eac-89de28773ea0.svg",
                alt: "Stats Image",
            },
            stats: [
                {
                    title: "1800+",
                    description: "Cities",
                },
                {
                    title: "200+",
                    description: "Corporate Partners",
                },
                {
                    title: "1.1M+",
                    description: "Employees Onboarded",
                },
                {
                    title: "47M+",
                    description: "Pharmacy Order Delivered",
                },
                {
                    title: "30+",
                    description: "Network Partners",
                },
            ],
        },
        solutionSection: {
            header: "<span>Tailored <span style='color:#FF5443'>solutions</span> for every need</span>",
            solutions: [
                {
                    title: "Corporate Wellness",
                    details: {
                        image: {
                            url: "https://onemg.gumlet.io/staging/2babbcf3-35a7-4925-8b2a-81982cb85666.svg",
                            alt: "",
                            width: "",
                            height: "",
                        },
                        theme: "#cde7fd",
                        text: "Support your team’s well-being and boost their overall productivity with our suite of services tailored to meet the unique needs of your employees.",
                        listHeader: "Our modular offerings include: ",
                        list: ["Cashless pharmacy", "Health checkups", "Online doctor consultations"],
                        cta: {
                            label: "Know more about Corporate Solutions",
                            redirectionURL: "products/business",
                        },
                    },
                },
                {
                    title: "Hospital Services",
                    details: {
                        theme: "#FBD9E8",
                        text: "Streamline operations, boost profitability and enhance patient satisfaction with our end-to-end pharmacy management solutions.",
                        listHeader: "Transform your pharmacy operations with:",
                        list: [
                            "One-stop procurement and supply chain management",
                            "Tech-enabled operations",
                            "Patient lifecycle management",
                        ],
                        cta: {
                            label: "Know more about Hospital Services",
                            redirectionURL: "products/hospitalServices",
                        },
                    },
                },
                {
                    title: pspTitle,
                    details: {
                        theme: "#7EDCAA",
                        text: "Connecting the dots between affordability, accessibility, and quality care for complex medical journeys. ",
                        listHeader: "Collaborate with us to simplify patient outreach:",
                        list: [
                            "Trusted distribution network",
                            "Tailored Comprehensive programs",
                            "Data-driven patient insights",
                        ],
                        cta: {
                            label: "Know more about Patient Support Program",
                            redirectionURL: "products/patientSupportProgram",
                        },
                    },
                },
                {
                    title: "Insurance",
                    details: {
                        theme: "#F9D4FF",
                        text: "Revolutionise insurance offerings with our comprehensive healthcare solutions, enhancing experiences for insurers and their clients.",
                        listHeader: "Partner with us for:",
                        list: [
                            "Pan-India service capability",
                            "Cashless pharmacy & diagnostics",
                            "PPMC, AHCs & MERs",
                        ],
                        cta: {
                            label: "Know more about Insurance",
                            redirectionURL: "products/insurance",
                        },
                    },
                },
                {
                    title: "Strategic Partners",
                    details: {
                        theme: "#FBD0B8",
                        text: "Optimise your healthcare ecosystem with our integrated solutions across ePharmacy and eDiagnostics.",
                        listHeader: "Our available models include:",
                        list: ["API Integration", "SSO Integration", "Done-in-One Ordering"],
                        cta: {
                            label: "Know more about Strategic Partners",
                            redirectionURL: "products/healthPartner",
                        },
                    },
                },
                {
                    title: "Health Associates",
                    details: {
                        theme: "#FBD0B8",
                        text: "Join the growing network of health partners and help millions stay healthier, while building a successful business.",
                        list: [
                            "Become an entrepreneur",
                            "Earn on every order",
                            "Bring quality healthcare to your community",
                        ],
                        cta: {
                            label: "Know more about Health Associates",
                            redirectionURL: "products/healthAssociates",
                        },
                    },
                },
                {
                    title: "Advertise with us",
                    details: {
                        theme: "#FBD0B8",
                        listHeader: "Advertise with us to get:",
                        text: "Leverage the power of associating with a trusted brand with a wide customer reach and enhance your brand’s visibility.",
                        list: [
                            "Advanced analytics & insights",
                            "Scalable & customised solutions",
                            "Engage with a large & active audience",
                        ],
                        cta: {
                            label: "Know more about Advertising",
                            redirectionURL: "products/advertiseWithUs",
                        },
                    },
                },
                {
                    title: "Authorised Collection Centres",
                    details: {
                        theme: "#FBD9E8",
                        text: "Become a Tata 1mg Labs Authorised Collection Centre Partner and deliver high-quality diagnostics services in your city.",
                        listHeader: "Here’s what you gain:",
                        list: [
                            "Start with a nominal investment",
                            "Dedicated sales team focused on growth",
                            "Comprehensive support system",
                        ],
                        cta: {
                            label: "Know more about Authorised Collection Centres",
                            redirectionURL: "products/authorisedDiagnosticCollectionCentre",
                        },
                    },
                },
            ],
        },
        employeeWellBeingSection: {
            header: "Enhancing Employee Well-being",
            subText1:
                "We understand the unique health needs of corporate employees. thus we offer tailored services designed to promote wellness and support your busy lifestyle. ",
            image: {
                url: "",
                alt: "",
            },
            features: [
                "Annual Health Checkup",
                "Improve Employee Engagement",
                "Single point coordination",
                "Modular and on-demand Plans",
                "Priority Services",
                "Health Reports",
            ],
            stats: [
                {
                    title: "1800+",
                    description: "Cities",
                },
                {
                    title: "200+",
                    description: "Corporate Partners",
                },
                {
                    title: "1.1M+",
                    description: "Employees Onboarded",
                },
                {
                    title: "47M+",
                    description: "Pharmacy Order Delivered",
                },
                {
                    title: "30+",
                    description: "Network Partners",
                },
            ],
        },
        wellnessJourneySection: {
            text: "Empowering Your Wellness Journey by",
            subText:
                "We understand the unique health needs of corporate employees, thus we offer tailored services designed to promote wellness and support your busy lifestyle. ",
            products: [
                {
                    title: "Annual Health Checkups",
                    description: "Annual Health Check ups, Pre employment health check ups.",
                    key: "annualHealthCheckups",
                    details: {
                        image: {
                            url: "http://",
                            alt: "",
                            width: "",
                            height: "",
                        },
                        text: "Annual Health Checkups",
                        key: "annualHealthCheckupsPopup",
                        cta: {
                            label: "Annual Health Checkups",
                        },
                    },
                },
                {
                    title: "Cashless Pharmacy",
                    description: "Better Discounts, Digital Invoicing and Reconciliation Support.",
                },
                {
                    title: "Online Doctor Consultations",
                    description: "24X7 Doctor Access, with online prescription delivery",
                },
                {
                    title: "Onsite Checkup Camps",
                    description: "Dental, Eye and General health checkup camps with ECG,PFT etc.",
                },
                {
                    title: "Wellness Workshop",
                    description: "We understand the unique health needs of corporate employees.",
                },
                {
                    title: "Emotional Wellness",
                    description: "We understand the unique health needs of corporate employees",
                },
                {
                    title: "Occupational Health Clinics",
                    description: "We understand the unique health needs of corporate employees.",
                },
                {
                    title: "Emergency Medical Services",
                    description: "We understand the unique health needs of corporate employees.",
                },
                {
                    title: "Conditional Care Programs",
                    description: "We understand the unique health needs of corporate employees",
                },
                {
                    title: "Health Risk Assessments",
                    description: "We understand the unique health needs of corporate employees",
                },
            ],
        },
        ourJourneySection: {
            header: "Creating <span style='color:#FF5443'>success stories</span> with <span style='color:#FF5443'>our partners</span>",
            subheader: "",
            showCaseStudies: false,
            partners: [
                [
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                        active: true,
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                        active: false,
                    },
                ],
                [
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                        active: false,
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                        active: true,
                    },
                ],
                [
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                        active: true,
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                        active: false,
                    },
                ],
                [
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                        active: false,
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                        active: true,
                    },
                ],
            ],
            partnersMweb: [
                {
                    backgroundColor: "#E2F1E9",
                    logo: {
                        url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                        alt: "",
                    },
                    highlightText: "Some highlight that we want to show for the success story",
                    cta: {
                        label: "Read more",
                    },
                    absImage: {
                        url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                        alt: "",
                    },
                },
                {
                    backgroundColor: "rgba(251, 162, 135, 0.15);",
                    logo: {
                        url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                        alt: "",
                    },
                    highlightText: "Some highlight that we want to show for the success story",
                    cta: {
                        label: "Read more",
                    },
                    absImage: {
                        url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                        alt: "",
                    },
                },
                {
                    backgroundColor: "#E2F1E9",
                    logo: {
                        url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                        alt: "",
                    },
                    highlightText: "Some highlight that we want to show for the success story",
                    cta: {
                        label: "Read more",
                    },
                    absImage: {
                        url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                        alt: "",
                    },
                },
                {
                    backgroundColor: "rgba(251, 162, 135, 0.15);",
                    logo: {
                        url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                        alt: "",
                    },
                    highlightText: "Some highlight that we want to show for the success story",
                    cta: {
                        label: "Read more",
                    },
                    absImage: {
                        url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                        alt: "",
                    },
                },
                {
                    backgroundColor: "#E2F1E9",
                    logo: {
                        url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                        alt: "",
                    },
                    highlightText: "Some highlight that we want to show for the success story",
                    cta: {
                        label: "Read more",
                    },
                    absImage: {
                        url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                        alt: "",
                    },
                },
                {
                    backgroundColor: "rgba(251, 162, 135, 0.15);",
                    logo: {
                        url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                        alt: "",
                    },
                    highlightText: "Some highlight that we want to show for the success story",
                    cta: {
                        label: "Read more",
                    },
                    absImage: {
                        url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                        alt: "",
                    },
                },
            ],
            showSection: true,
            subText: "Many Other Partners",
            otherPartners: [
                {
                    url: "https://onemg.gumlet.io/staging/7f0323c0-2798-4de3-b50f-7abdb37e9aee.png",
                    alt: "Air India",
                },
                {
                    url: "https://onemg.gumlet.io/staging/34802cbf-1868-4651-9dd2-7385c175d308.png",
                    alt: "Starbucks",
                },
                {
                    url: "https://onemg.gumlet.io/staging/029fd791-c0ef-4dc5-aacd-bcba8e3abacf.png",
                    alt: "TCS",
                },
                {
                    url: "https://onemg.gumlet.io/staging/074b7da6-c846-4b05-bba2-0515959c5078.png",
                    alt: "Air India Express",
                },
                {
                    url: "https://onemg.gumlet.io/staging/07258ed1-6778-40e1-9950-a88c64c04263.png",
                    alt: "Tata Power",
                },
                {
                    url: "https://onemg.gumlet.io/staging/73981788-697f-4b74-860c-2f6b0b5b7b69.png",
                    alt: "SBI",
                },
                {
                    url: "https://onemg.gumlet.io/staging/0fa3eb9e-091d-4d00-88b7-c778f2ca0e30.png",
                    alt: "TATA MOTORS",
                },
                {
                    url: "https://onemg.gumlet.io/staging/ca2db65c-7942-488f-b52b-8f7c2a03c077.png",
                    alt: "IHCL",
                },
                {
                    url: "https://onemg.gumlet.io/staging/640735f7-a4a4-4579-9b61-eb0c90d21662.png",
                    alt: "Tata Projects",
                },
                {
                    url: "https://onemg.gumlet.io/staging/224464fb-b803-4c98-a6a3-45c487ec5ade.png",
                    alt: "REA India",
                },
                {
                    url: "https://onemg.gumlet.io/staging/d2a5d73d-c885-4d82-ad02-cfcb364b0e7f.png",
                    alt: "Tata Aia",
                },
                {
                    url: "https://onemg.gumlet.io/staging/83075d67-dc94-4c67-915c-e8f477fde81c.png",
                    alt: "Tata Technologies",
                },
            ],
        },
        messageFromCeoSection: {
            header: "<span>A message from  <span style='color:#FF5443'>Our CEO </span></span>",
            subHeader: "Leading with a vision and compassion",
            imageDweb: {
                url: "https://onemg.gumlet.io/staging/51028209-8e55-43b0-8dc0-f1be5baee91b.svg",
                alt: "PT image",
            },
            imageMweb: {
                url: "https://onemg.gumlet.io/staging/e399946d-65dd-4251-a223-03a9c46c354b.svg",
                alt: "PT image",
            },
            message:
                "We are driven by a singular mission to make high-quality healthcare understandable, accessible, and affordable for millions across India. In today’s fast-paced world, healthcare is not just limited to treatment; it’s about education, prevention, and proactive engagement. As we continue to innovate and expand, our commitment to excellence and integrity remains steadfast.</br>We are proud to partner with businesses - both established and emerging - that share our passion for making a meaningful impact. Together, we are transforming lives by delivering exceptional healthcare services that drive positive change.</br></br>To our current and future partners—your trust in Tata 1mg is what inspires us. Together, we can empower communities and revolutionise healthcare accessibility for a healthier tomorrow.</br></br>Warm regards,</br>Prashant Tandon</br>Chief Executive Officer",
        },
        form: {
            header: "<span><span style='color:#FF5443'>Let's Collaborate</span> for Success</span>",
            fields: [
                {
                    type: "text",
                    label: "Name*",
                    name: "name",
                    required: true,
                    minLength: 2,
                },
                {
                    type: "email",
                    label: "Work Email ID*",
                    name: "official_email",
                    required: true,
                },
                {
                    type: "tel",
                    label: "Contact number*",
                    name: "number",
                    required: true,
                },
                {
                    type: "text",
                    label: "Organisation Name*",
                    name: "organization_name",
                    required: true,
                    minLength: 2,
                },
                {
                    type: "select",
                    label: "Employee Strength*",
                    name: "employee_strength",
                    required: true,
                    options: [
                        { value: "<500", label: "Less than 500" },
                        { value: "500-2000", label: "500 to 2000" },
                        { value: ">2000", label: "More than 2000" },
                    ],
                },
                {
                    type: "select",
                    label: "Services you would like to know about*",
                    name: "required_services",
                    required: true,
                    options: [
                        { value: "Health Checks", label: "Health Checks" },
                        { value: "Medicine Delivery", label: "Medicine Delivery" },
                        { value: "Consultations", label: "Consultations" },
                        { value: "Insurance Products", label: "Insurance Products" },
                        { value: "Medical Rooms", label: "Medical Rooms" },
                        { value: "Other", label: "Other: Please mention in the requirements" },
                    ],
                },
                {
                    type: "text",
                    label: "Please mention your requirement",
                    name: "requirement",
                    required: false,
                },
            ],
            cta: {
                label: "Get In Touch",
                type: "primary",
            },
            message: "Your request has been registered! We will get in touch with you shortly.",
        },
        footer: {
            header: "Want to Partner with us?",
        },
    },
}

export const NAVBAR_DATA = {
    leftNavbar: {
        logo: {
            text: {
                url: "https://www.1mg.com/images/tata_1mg_logo.svg",
                alt: "",
            },
            url: "/",
        },
        home: {
            text: "Home",
            url: "/partnerships",
        },
        ourSolutions: {
            text: "Our Solutions",
            dropdownList: [
                {
                    title: "Corporate Wellness",
                    redirectionURL: "products/business",
                    image: {
                        url: "https://onemg.gumlet.io/staging/e0b4a824-0a80-4abe-a65c-5506f2c093d2.svg",
                        alt: "",
                    },
                },
                {
                    title: "Hospital Services",
                    redirectionURL: "products/hospitalServices",
                    image: {
                        url: "https://onemg.gumlet.io/staging/9f9801ea-8d5b-4391-8bf2-ba0706659d99.svg",
                        alt: "flower",
                    },
                },
                {
                    title: pspTitle,
                    redirectionURL: "products/patientSupportProgram",
                    image: {
                        url: "https://1mg-gumlet.s3.ap-south-1.amazonaws.com/psp/website/pspicon.svg",
                        alt: "flower",
                    },
                },
                {
                    title: "Insurance",
                    redirectionURL: "products/insurance",
                    image: {
                        url: "https://1mg-gumlet.s3.ap-south-1.amazonaws.com/psp/website/insuranceicon.svg",
                        alt: "flower",
                    },
                },
                {
                    title: "Strategic Partners",
                    redirectionURL: "products/healthPartner",
                    image: {
                        url: "https://onemg.gumlet.io/staging/6d67421e-f3bd-4be6-a4aa-d210ff21f4da.svg",
                        alt: "",
                    },
                },
                {
                    title: "Health Associates",
                    redirectionURL: "products/healthAssociates",
                    image: {
                        url: "https://onemg.gumlet.io/staging/6d67421e-f3bd-4be6-a4aa-d210ff21f4da.svg",
                        alt: "",
                    },
                },
                {
                    title: "Advertise with us",
                    redirectionURL: "products/advertiseWithUs",
                    image: {
                        url: "https://onemg.gumlet.io/staging/6d67421e-f3bd-4be6-a4aa-d210ff21f4da.svg",
                        alt: "",
                    },
                },
                {
                    title: "Authorised Collection Centres",
                    redirectionURL: "products/authorisedDiagnosticCollectionCentre",
                    image: {
                        url: "https://onemg.gumlet.io/staging/9f9801ea-8d5b-4391-8bf2-ba0706659d99.svg",
                        alt: "",
                    },
                },
            ],
        },
    },
    rightNavbar: {
        aboutUs: {
            text: "About Us",
            url: "https://www.1mg.com/aboutus",
        },
        contactUs: {
            text: "Contact Us",
            url: "#contactUs",
        },
    },
}

export const FOOTER_DATA = {
    logo: {
        text: {
            url: "https://www.1mg.com/images/tata_1mg_logo.svg",
            alt: "",
        },
        url: "/",
    },
    title: "India's only LegitScript and ISO/ IEC 27001:2022 certified online healthcare platform",
    ourPolicies: {
        title: "Our Policies",
        list: [
            {
                title: "Privacy Policy",
                redirectUrl: "https://www.1mg.com/PrivacyPolicy",
            },
            {
                title: "Terms and Conditions",
                redirectUrl: "/Tnc",
            },
            {
                title: "Editorial Policy",
                redirectUrl: "/editorial-policy-processes",
            },
            {
                title: "Return Policy",
                redirectUrl: "/return-policy",
            },
            {
                title: "IP Policy",
                redirectUrl: "/ip-policy",
            },
            {
                title: "Grievance Redressal Policy",
                redirectUrl: "/grievance-redressal-policy",
            },
            {
                title: "Fake Jobs and Fraud ",
                redirectUrl: "/FakeJobsAndFraudDisclaimer",
            },
        ],
    },
    ourSolution: {
        title: "Our Solution",
        list: [
            {
                title: "Corporate wellness",
                redirectUrl: "/partnerships/products/business",
            },
            {
                title: "Hospital Services",
                redirectUrl: "/partnerships/products/hospitalServices",
            },
            {
                title: pspTitle,
                redirectUrl: "/partnerships/products/patientSupportProgram",
            },
            {
                title: "Insurance",
                redirectUrl: "/partnerships/products/insurance",
            },
            {
                title: "Strategic Partners",
                redirectUrl: "/partnerships/products/healthPartner",
            },
            {
                title: "Health Associates",
                redirectUrl: "/partnerships/products/healthAssociates",
            },
            {
                title: "Advertise with us",
                redirectUrl: "/partnerships/products/advertiseWithUs",
            },
            {
                title: "Collection Centres",
                redirectUrl: "/partnerships/products/authorisedDiagnosticCollectionCentre",
            },
        ],
    },
    Reliable: {
        icon: {
            url: "https://onemg.gumlet.io/staging/3bdb5057-16f1-41bc-a620-2b469b10db56.svg",
            alt: "Reliable",
        },
        title: "Reliable",
        text: "All products displayed on Tata 1mg are procured from verified and licensed pharmacies. All labs listed on the platform are accredited",
    },
    Secure: {
        icon: {
            url: "https://onemg.gumlet.io/staging/1991cd17-5f9c-48f9-915e-8029f830043f.svg",
            alt: "Secure",
        },
        title: "Secure",
        text: "Tata 1mg uses Secure Sockets Layer (SSL) 128-bit encryption and is Payment Card Industry Data Security Standard (PCI DSS) compliant",
    },
    Affordable: {
        icon: {
            url: "https://onemg.gumlet.io/staging/2444aad2-1746-4046-8d68-8738e26b970c.svg",
            alt: "Affordable",
        },
        title: "Affordable",
        text: "Find affordable medicine substitutes, save up to 50% on health products, up to 80% off on lab tests and free doctor consultations.",
    },
    Connectwithus: {
        title: "Connect with us",
        icons: [
            {
                redirectUrl: "https://www.facebook.com/1mgOfficial",
                url: "https://onemg.gumlet.io/staging/b099aae1-511b-400a-aee2-97bffee8750e.svg",
                alt: "Facebook",
            },
            {
                redirectUrl: "https://www.instagram.com/1mgofficialpage",
                url: "https://onemg.gumlet.io/staging/2173a994-6a9c-4444-9314-6e4c8570ebd4.svg",
                alt: "Instagram",
            },
            {
                redirectUrl: "https://www.linkedin.com/company/1mg",
                url: "https://onemg.gumlet.io/staging/04ca8ed8-5932-4eb8-a10f-ff732f515a85.svg",
                alt: "LinkedIn",
            },
            {
                redirectUrl: "https://medium.com/1mgofficial",
                url: "https://onemg.gumlet.io/staging/aa1677fd-4473-4a0e-ba0c-9068a067e74f.svg",
                alt: "Medium",
            },
            {
                redirectUrl: "https://twitter.com/1mgofficial",
                url: "https://onemg.gumlet.io/staging/317f81f9-049b-4b26-abb5-d688d73d2d7e.svg",
                alt: "Twitter",
            },
            {
                redirectUrl: "https://www.youtube.com/c/1mgofficial",
                url: "https://onemg.gumlet.io/staging/a57905d5-1c19-4d2b-9f16-db6f087def7f.svg",
                alt: "YouTube",
            },
        ],
    },
    Footer: {
        title: "© 2024 Tata 1mg. All rights reserved. All medicines are dispensed in compliance with the Drugs and Cosmetics Act, 1940 and Drugs and Cosmetics Rules, 1945. We do not process requests for Schedule X and habit forming drugs.",
    },
}

export const FOOTER_BACKGROUND_IMAGE_AND_ANIMATIONS = {
    landingPage: {
        animationImage: {
            url: "https://onemg.gumlet.io/staging/4940663b-8015-4357-b534-7d0b076e592c.svg",
            alt: footerImageAltText,
        },
        backgroundImage: {
            url: "https://onemg.gumlet.io/staging/be953a16-f7da-451b-a0ea-76eeea7fb009.svg",
            alt: backgroundImageAltText,
        },
    },
    business: {
        animationImage: {
            url: "https://onemg.gumlet.io/staging/053a73a8-9181-42af-9d17-ff21f8d72c26.svg",
            alt: footerImageAltText,
        },
        backgroundImage: {
            url: "https://onemg.gumlet.io/staging/0becbc56-1d27-4f1f-be16-48cedcc17b23.svg",
            alt: backgroundImageAltText,
        },
    },
    healthPartner: {
        animationImage: {
            url: "https://onemg.gumlet.io/staging/51e264c1-a24e-43e2-bf04-e01a15e5b1eb.svg",
            alt: footerImageAltText,
        },
        backgroundImage: {
            url: "https://onemg.gumlet.io/staging/a4891df5-18fd-4571-bed1-70692df80be7.svg",
            alt: backgroundImageAltText,
        },
    },
    healthAssociates: {
        animationImage: {
            url: "https://onemg.gumlet.io/staging/51e264c1-a24e-43e2-bf04-e01a15e5b1eb.svg",
            alt: footerImageAltText,
        },
        backgroundImage: {
            url: "https://onemg.gumlet.io/staging/a4891df5-18fd-4571-bed1-70692df80be7.svg",
            alt: backgroundImageAltText,
        },
    },
    advertiseWithUs: {
        animationImage: {
            url: "https://onemg.gumlet.io/staging/51e264c1-a24e-43e2-bf04-e01a15e5b1eb.svg",
            alt: footerImageAltText,
        },
        backgroundImage: {
            url: "https://onemg.gumlet.io/staging/a4891df5-18fd-4571-bed1-70692df80be7.svg",
            alt: backgroundImageAltText,
        },
    },
    authorisedDiagnosticCollectionCentre: {
        animationImage: {
            url: "https://onemg.gumlet.io/staging/743236e7-ab14-4442-a7a5-2f87c4b72d83.svg",
            alt: footerImageAltText,
        },
        backgroundImage: {
            url: "https://onemg.gumlet.io/staging/787d3add-92b7-4441-953e-6e2bda1e7772.svg",
            alt: backgroundImageAltText,
        },
    },
    vendorOnboarding: {
        animationImage: {
            url: "https://onemg.gumlet.io/staging/15dcf3d7-aaf6-449e-9c5d-207404be8231.svg",
            alt: footerImageAltText,
        },
        backgroundImage: {
            url: "https://onemg.gumlet.io/staging/95786c08-1417-459d-a66a-c6589b37a8f2.svg",
            alt: backgroundImageAltText,
        },
    },
    hospitalServices: {
        animationImage: {
            url: "https://onemg.gumlet.io/staging/743236e7-ab14-4442-a7a5-2f87c4b72d83.svg",
            alt: footerImageAltText,
        },
        backgroundImage: {
            url: "https://onemg.gumlet.io/staging/787d3add-92b7-4441-953e-6e2bda1e7772.svg",
            alt: backgroundImageAltText,
        },
    },
    patientSupportProgram: {
        animationImage: {
            url: "https://1mg-gumlet.s3.ap-south-1.amazonaws.com/psp/website/pspfooterflower.svg",
            alt: footerImageAltText,
        },
        backgroundImage: {
            url: "https://1mg-gumlet.s3.ap-south-1.amazonaws.com/psp/website/pspfooterimage.svg",
            alt: backgroundImageAltText,
        },
    },
    insurance: {
        animationImage: {
            url: "https://onemg.gumlet.io/staging/15dcf3d7-aaf6-449e-9c5d-207404be8231.svg",
            alt: footerImageAltText,
        },
        backgroundImage: {
            url: "https://onemg.gumlet.io/staging/95786c08-1417-459d-a66a-c6589b37a8f2.svg",
            alt: backgroundImageAltText,
        },
    },
}
